import React from 'react';
import PropTypes from 'prop-types';

import { Table, TableBody, TableRow, TableCell } from '@material-ui/core';

const ReasonSummary = props => {
    const { record } = props;

    return (
        <div>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell>
                            <label>Reason</label>
                        </TableCell>
                        <TableCell style={{ textAlign: 'right' }}>
                            {record.reason}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </div>
    );
};

ReasonSummary.propTypes = {
    record: PropTypes.object,
};

export default ReasonSummary;
